import { render, staticRenderFns } from "./tInformation.vue?vue&type=template&id=c481fd58&scoped=true"
import script from "./tInformation.vue?vue&type=script&lang=js"
export * from "./tInformation.vue?vue&type=script&lang=js"
import style0 from "./tInformation.vue?vue&type=style&index=0&id=c481fd58&prod&scoped=true&lang=css"
import style1 from "./tInformation.vue?vue&type=style&index=1&id=c481fd58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c481fd58",
  null
  
)

export default component.exports